/*
    BEEP BOP BOOP - I AM AN AUTO GENERATED FILE - DO NOT EDIT ME MANUALLY
*/


// Name: Resource loading hooks 

import React from 'react';
import useResourceLoader from "../../clientShared/hooks/useResourceLoader";
import {
	RESOURCE_TYPE_USER_ACCOUNT,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE,
	RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE,
	RESOURCE_TYPE_USER_HISTORY_ENTRY,
	RESOURCE_TYPE_BALANCE_CHANGE_LOG,
	RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT,
	RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA,
	RESOURCE_TYPE_USER_ACCOUNT_SETTINGS,
	RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST,
	RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION,
	RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING,
	RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS,
	RESOURCE_TYPE_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE,
	RESOURCE_TYPE_PASSWORD,
	RESOURCE_TYPE_EXPIRED_PASSWORD,
	RESOURCE_TYPE_PASSWORD_RESET,
	RESOURCE_TYPE_DEPOSIT,
	RESOURCE_TYPE_DEPOSIT_INVITE,
	RESOURCE_TYPE_DEPOSIT_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_INTEREST,
	RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY,
	RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_USER_STATS,
	RESOURCE_TYPE_DEPOSIT_BANK_MAPPING,
	RESOURCE_TYPE_DEPOSITS_BULK_IMPORT,
	RESOURCE_TYPE_DEPOSIT_INTEREST_LOG,
	RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST,
	RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS,
	RESOURCE_TYPE_PMC_REPORT_TIMETABLE,
	RESOURCE_TYPE_DEPOSIT_GROUP,
	RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT,
	RESOURCE_TYPE_DEPOSIT_USER_GROUP,
	RESOURCE_TYPE_PROPERTY_GROUP,
	RESOURCE_TYPE_PROPERTY_USER_GROUP,
	RESOURCE_TYPE_DISPUTE,
	RESOURCE_TYPE_DISPUTE_SPLIT,
	RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST,
	RESOURCE_TYPE_PROPERTY,
	RESOURCE_TYPE_PROPERTY_ADDRESS,
	RESOURCE_TYPE_COMPLIANCE,
	RESOURCE_TYPE_COMPLIANCE_RULE,
	RESOURCE_TYPE_COMPLIANCE_HISTORY,
	RESOURCE_TYPE_EMAIL_TEMPLATE,
	RESOURCE_TYPE_EMAIL_VERIFICATION,
	RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD,
	RESOURCE_TYPE_EMAIL_EVENT,
	RESOURCE_TYPE_SENT_EMAIL,
	RESOURCE_TYPE_MAILBOX,
	RESOURCE_TYPE_MAILBOX_META_DATA,
	RESOURCE_TYPE_MAILBOX_MESSAGE,
	RESOURCE_TYPE_PERMISSION_ENTRY,
	RESOURCE_TYPE_PERMISSION_LOG_ENTRY,
	RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS,
	RESOURCE_TYPE_RESOURCE_PERMISSIONS,
	RESOURCE_TYPE_ORGANIZATION,
	RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE,
	RESOURCE_TYPE_INVOICE,
	RESOURCE_TYPE_INVOICE_ITEM,
	RESOURCE_TYPE_PAYMENT_REQUEST,
	RESOURCE_TYPE_STRIPE_PAYMENT_LOG,
	RESOURCE_TYPE_USER_WITHDRAW,
	RESOURCE_TYPE_PRIORITY_ACH_PAYMENT,
	RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT,
	RESOURCE_TYPE_LOAN_APPLICATION,
	RESOURCE_TYPE_LOAN_SYSTEM_INFO,
	RESOURCE_TYPE_LOAN,
	RESOURCE_TYPE_LOAN_HISTORY,
	RESOURCE_TYPE_LOAN_PAYMENT_LOG,
	RESOURCE_TYPE_STRIPE_WEBHOOK_LOG,
	RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO,
	RESOURCE_TYPE_SEZZLE_ORDER,
	RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT,
	RESOURCE_TYPE_BANK_ACCOUNT,
	RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE,
	RESOURCE_TYPE_BANK_ACCOUNT_INTEREST,
	RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD,
	RESOURCE_TYPE_BANK_TRANSFER,
	RESOURCE_TYPE_BULK_FUNDS_TRANSFER,
	RESOURCE_TYPE_FUNDS_LOCK,
	RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG,
	RESOURCE_TYPE_RELEASED_FUNDS_LOCK,
	RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER,
	RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG,
	RESOURCE_TYPE_EVENT,
	RESOURCE_TYPE_EVENT_HOOK,
	RESOURCE_TYPE_NOTIFICATION,
	RESOURCE_TYPE_ACTION_ITEM,
	RESOURCE_TYPE_UPDATE_LOG_ENTRY,
	RESOURCE_TYPE_STORAGE_FILE,
	RESOURCE_TYPE_ATTACHED_STORAGE_FILES,
	RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY,
	RESOURCE_TYPE_SNAPSHOT,
	RESOURCE_TYPE_IP_ADDRESS,
	RESOURCE_TYPE_KNOWN_IP_ADDRESS,
	RESOURCE_TYPE_USER_AGENT,
	RESOURCE_TYPE_KNOWN_USER_AGENT,
	RESOURCE_TYPE_SYSTEM_STATS,
	RESOURCE_TYPE_RESOURCE_NOTE,
	RESOURCE_TYPE_DEPOSIFY_TAG,
	RESOURCE_TYPE_PERMANENT_LINK,
	RESOURCE_TYPE_ONLINE_USER,
	RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS,
	RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_XML,
	RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT,
	RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT,
	RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS,
	RESOURCE_TYPE_YARDI_VOYAGER_PET,
	RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE,
	RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_EVENT,
	RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT,
	RESOURCE_TYPE_YARDI_VOYAGER_PHONE,
	RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS,
	RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR,
	RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY,
	RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS
} from "../constants/resourceTypeConstants";
import {
	UserAccountSelector,
	UserAccountBalanceSelector,
	UserAccountBalanceSourceSelector,
	UserHistoryEntrySelector,
	BalanceChangeLogSelector,
	InternationalUserBankAccountSelector,
	USDomesticUserBankAccountSelector,
	UserBankAccountDeltaSelector,
	UserAccountSettingsSelector,
	AdminGhostUserAccountSelector,
	UserAccountFinalizationSelector,
	ThirdPartyUserAccountMappingSelector,
	PreviousEmailAddressSelector,
	PendingEmailChangeSelector,
	ArchivedPendingEmailChangeSelector,
	PasswordSelector,
	ExpiredPasswordSelector,
	PasswordResetSelector,
	DepositSelector,
	DepositInviteSelector,
	DepositAdjustmentSelector,
	DepositInterestSelector,
	DepositHistoryEntrySelector,
	DepositCloseRequestSelector,
	DepositUserStatsSelector,
	DepositBankMappingSelector,
	DepositBulkImportSelector,
	DepositInterestLogSelector,
	ArchivedDepositCloseRequestSelector,
	DepositWithheldFundsSelector,
	PMCReportTimetableSelector,
	DepositGroupSelector,
	DepositPostCloseAdjustmentSelector,
	DepositUserGroupSelector,
	PropertyGroupSelector,
	PropertyUserGroupSelector,
	DisputeSelector,
	DisputeSplitSelector,
	DisputeInterventionRequestSelector,
	PropertySelector,
	PropertyAddressSelector,
	ComplianceSelector,
	ComplianceRuleSelector,
	ComplianceHistorySelector,
	EmailTemplateSelector,
	EmailVerificationSelector,
	EmailVerificationRecordSelector,
	EmailEventSelector,
	SentEmailSelector,
	MailboxSelector,
	MailboxMetaDataSelector,
	MailboxMessageSelector,
	PermissionEntrySelector,
	PermissionLogEntrySelector,
	PermissionsOrganizationSettingsSelector,
	ResourcePermissionSelector,
	OrganizationSelector,
	OrganizationResourcePermissionRuleSelector,
	InvoiceSelector,
	InvoiceItemSelector,
	PaymentRequestSelector,
	StripePaymentLogSelector,
	UserWithdrawSelector,
	PriorityACHPaymentSelector,
	PriorityACHRecurringPaymentSelector,
	LoanApplicationSelector,
	LoanSystemInfoSelector,
	LoanSelector,
	LoanHistorySelector,
	LoanPaymentLogSelector,
	StripeWebhookLogSelector,
	UserAccountPaymentProviderInfoSelector,
	SezzleOrderSelector,
	SezzleWebhookEventSelector,
	BankAccountSelector,
	BankAccountHistoricalInterestRateSelector,
	BankAccountInterestSelector,
	BankAccountBalanceRecordSelector,
	BankTransferSelector,
	BulkFundsTransferSelector,
	FundsLockSelector,
	FundsLockReleaseLogSelector,
	ReleasedFundsLockSelector,
	BalanceSourceTransferSelector,
	CreditUserAccountLogSelector,
	EventSelector,
	EventHookSelector,
	NotificationSelector,
	ActionItemSelector,
	UpdateLogSelector,
	StorageFileSelector,
	AttachedStorageFilesSelector,
	SystemHistoryEntrySelector,
	SnapshotSelector,
	IPAddressSelector,
	KnownIPAddressSelector,
	UserAgentSelector,
	KnownUserAgentSelector,
	SystemStatsSelector,
	ResourceNoteSelector,
	DeposifyTagSelector,
	PermanentLinkSelector,
	OnlineUserSelector,
	FrontendGeneralSettingsSelector,
	YardiScreeningWorksProXMLSelector,
	YardiVoyagerXMLSelector,
	YardiVoyagerTransactionSelector,
	YardiVoyagerResidentSelector,
	YardiVoyagerResidentCustomColumnSelector,
	YardiVoyagerPropertyUnitSelector,
	YardiVoyagerPropertySelector,
	YardiVoyagerPMCServiceInterfaceVersionSelector,
	YardiVoyagerPMCSelector,
	YardiVoyagerPMCCredentialsSelector,
	YardiVoyagerPetSelector,
	YardiVoyagerILSGuestCardEventSelector,
	YardiVoyagerChargeSelector,
	YardiVoyagerChargeCodeSelector,
	YardiVoyagerDepositCreateIntentSelector,
	YardiVoyagerDepositCloseIntentSelector,
	YardiVoyagerDepositWithholdIntentSelector,
	YardiVoyagerEventSelector,
	YardiVoyagerFlexDepositIntentSelector,
	YardiVoyagerPhoneSelector,
	YardiVoyagerOtherOccupantSelector,
	YardiVoyagerPMCCustomColumnSettingsSelector,
	YardiVoyagerPMCStatsSelector,
	YardiVoyagerPMCStatsCollectorSelector,
	YardiVoyagerActiveScanLogEntrySelector,
	YardiVoyagerSystemSettingsSelector}
from "../selectors/modernResourceSelectors";

export const useUserAccountLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_USER_ACCOUNT, UserAccountSelector, 'userAccount');
};

export const useUserAccountBalanceLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_USER_ACCOUNT_BALANCE, UserAccountBalanceSelector, 'userAccountBalance');
};

export const useUserAccountBalanceSourceLoader = (sourceUID) => {
	return useResourceLoader(sourceUID, RESOURCE_TYPE_USER_ACCOUNT_BALANCE_SOURCE, UserAccountBalanceSourceSelector, 'userAccountBalanceSource');
};

export const useUserHistoryEntryLoader = (entryUID) => {
	return useResourceLoader(entryUID, RESOURCE_TYPE_USER_HISTORY_ENTRY, UserHistoryEntrySelector, 'historyEntry');
};

export const useBalanceChangeLogLoader = (changeLogUID) => {
	return useResourceLoader(changeLogUID, RESOURCE_TYPE_BALANCE_CHANGE_LOG, BalanceChangeLogSelector, 'balanceChangeLog');
};

export const useInternationalUserBankAccountLoader = (bankAccountUID) => {
	return useResourceLoader(bankAccountUID, RESOURCE_TYPE_INTERNATIONAL_USER_BANK_ACCOUNT, InternationalUserBankAccountSelector, 'bankAccount');
};

export const useUSDomesticUserBankAccountLoader = (bankAccountUID) => {
	return useResourceLoader(bankAccountUID, RESOURCE_TYPE_US_DOMESTIC_USER_BANK_ACCOUNT, USDomesticUserBankAccountSelector, 'bankAccount');
};

export const useUserBankAccountDeltaLoader = (deltaUID) => {
	return useResourceLoader(deltaUID, RESOURCE_TYPE_USER_BANK_ACCOUNT_DELTA, UserBankAccountDeltaSelector, 'userBankAccountDelta');
};

export const useUserAccountSettingsLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_USER_ACCOUNT_SETTINGS, UserAccountSettingsSelector, 'userAccountSettings');
};

export const useAdminGhostUserAccountLoader = (ghostAccountUID) => {
	return useResourceLoader(ghostAccountUID, RESOURCE_TYPE_USER_ACCOUNT_ADMIN_GHOST, AdminGhostUserAccountSelector, 'adminGhostUserAccount');
};

export const useUserAccountFinalizationLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_USER_ACCOUNT_FINALIZATION, UserAccountFinalizationSelector, 'userAccountFinalization');
};

export const useThirdPartyUserAccountMappingLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_THIRD_PARTY_USER_ACCOUNT_MAPPING, ThirdPartyUserAccountMappingSelector, 'thirdPartyUserAccountMapping');
};

export const usePreviousEmailAddressLoader = (previousEmailUID) => {
	return useResourceLoader(previousEmailUID, RESOURCE_TYPE_PREVIOUS_EMAIL_ADDRESS, PreviousEmailAddressSelector, 'previousEmailAddress');
};

export const usePendingEmailChangeLoader = (changeUID) => {
	return useResourceLoader(changeUID, RESOURCE_TYPE_PENDING_EMAIL_CHANGE, PendingEmailChangeSelector, 'pendingEmailChange');
};

export const useArchivedPendingEmailChangeLoader = (changeUID) => {
	return useResourceLoader(changeUID, RESOURCE_TYPE_ARCHIVED_PENDING_EMAIL_CHANGE, ArchivedPendingEmailChangeSelector, 'archivedPendingEmailChange');
};

export const usePasswordLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_PASSWORD, PasswordSelector, 'password');
};

export const useExpiredPasswordLoader = (expiredPasswordUID) => {
	return useResourceLoader(expiredPasswordUID, RESOURCE_TYPE_EXPIRED_PASSWORD, ExpiredPasswordSelector, 'expiredPassword');
};

export const usePasswordResetLoader = (resetUID) => {
	return useResourceLoader(resetUID, RESOURCE_TYPE_PASSWORD_RESET, PasswordResetSelector, 'passwordReset');
};

export const useDepositLoader = (depositUID) => {
	return useResourceLoader(depositUID, RESOURCE_TYPE_DEPOSIT, DepositSelector, 'deposit');
};

export const useDepositInviteLoader = (depositUID) => {
	return useResourceLoader(depositUID, RESOURCE_TYPE_DEPOSIT_INVITE, DepositInviteSelector, 'depositInvite');
};

export const useDepositAdjustmentLoader = (adjustmentUID) => {
	return useResourceLoader(adjustmentUID, RESOURCE_TYPE_DEPOSIT_ADJUSTMENT, DepositAdjustmentSelector, 'depositAdjustment');
};

export const useDepositInterestLoader = (interestUID) => {
	return useResourceLoader(interestUID, RESOURCE_TYPE_DEPOSIT_INTEREST, DepositInterestSelector, 'depositInterest');
};

export const useDepositHistoryEntryLoader = (entryUID) => {
	return useResourceLoader(entryUID, RESOURCE_TYPE_DEPOSIT_HISTORY_ENTRY, DepositHistoryEntrySelector, 'historyEntry');
};

export const useDepositCloseRequestLoader = (depositUID) => {
	return useResourceLoader(depositUID, RESOURCE_TYPE_DEPOSIT_CLOSE_REQUEST, DepositCloseRequestSelector, 'depositCloseRequest');
};

export const useDepositUserStatsLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_DEPOSIT_USER_STATS, DepositUserStatsSelector, 'depositUserStats');
};

export const useDepositBankMappingLoader = (mapUID) => {
	return useResourceLoader(mapUID, RESOURCE_TYPE_DEPOSIT_BANK_MAPPING, DepositBankMappingSelector, 'depositBankMapping');
};

export const useDepositBulkImportLoader = (bulkImportUID) => {
	return useResourceLoader(bulkImportUID, RESOURCE_TYPE_DEPOSITS_BULK_IMPORT, DepositBulkImportSelector, 'depositBulkImport');
};

export const useDepositInterestLogLoader = (entryUID) => {
	return useResourceLoader(entryUID, RESOURCE_TYPE_DEPOSIT_INTEREST_LOG, DepositInterestLogSelector, 'depositInterestLog');
};

export const useArchivedDepositCloseRequestLoader = (archiveUID) => {
	return useResourceLoader(archiveUID, RESOURCE_TYPE_ARCHIVED_DEPOSIT_CLOSE_REQUEST, ArchivedDepositCloseRequestSelector, 'archivedDepositCloseRequest');
};

export const useDepositWithheldFundsLoader = (withheldUID) => {
	return useResourceLoader(withheldUID, RESOURCE_TYPE_DEPOSIT_WITHHELD_FUNDS, DepositWithheldFundsSelector, 'depositWithheldFunds');
};

export const usePMCReportTimetableLoader = (timetableUID) => {
	return useResourceLoader(timetableUID, RESOURCE_TYPE_PMC_REPORT_TIMETABLE, PMCReportTimetableSelector, 'pmcReportTimetable');
};

export const useDepositGroupLoader = (groupUID) => {
	return useResourceLoader(groupUID, RESOURCE_TYPE_DEPOSIT_GROUP, DepositGroupSelector, 'depositGroup');
};

export const useDepositPostCloseAdjustmentLoader = (adjustmentUID) => {
	return useResourceLoader(adjustmentUID, RESOURCE_TYPE_DEPOSIT_POST_CLOSE_ADJUSTMENT, DepositPostCloseAdjustmentSelector, 'depositPostCloseAdjustment');
};

export const useDepositUserGroupLoader = (depositUID) => {
	return useResourceLoader(depositUID, RESOURCE_TYPE_DEPOSIT_USER_GROUP, DepositUserGroupSelector, 'depositUserGroup');
};

export const usePropertyGroupLoader = (groupUID) => {
	return useResourceLoader(groupUID, RESOURCE_TYPE_PROPERTY_GROUP, PropertyGroupSelector, 'propertyGroup');
};

export const usePropertyUserGroupLoader = (propertyUID) => {
	return useResourceLoader(propertyUID, RESOURCE_TYPE_PROPERTY_USER_GROUP, PropertyUserGroupSelector, 'propertyUserGroup');
};

export const useDisputeLoader = (disputeUID) => {
	return useResourceLoader(disputeUID, RESOURCE_TYPE_DISPUTE, DisputeSelector, 'dispute');
};

export const useDisputeSplitLoader = (splitUID) => {
	return useResourceLoader(splitUID, RESOURCE_TYPE_DISPUTE_SPLIT, DisputeSplitSelector, 'disputeSplit');
};

export const useDisputeInterventionRequestLoader = (requestUID) => {
	return useResourceLoader(requestUID, RESOURCE_TYPE_DISPUTE_INTERVENTION_REQUEST, DisputeInterventionRequestSelector, 'disputeInterventionRequest');
};

export const usePropertyLoader = (propertyUID) => {
	return useResourceLoader(propertyUID, RESOURCE_TYPE_PROPERTY, PropertySelector, 'property');
};

export const usePropertyAddressLoader = (propertyAddressUID) => {
	return useResourceLoader(propertyAddressUID, RESOURCE_TYPE_PROPERTY_ADDRESS, PropertyAddressSelector, 'propertyAddress');
};

export const useComplianceLoader = (complianceUID) => {
	return useResourceLoader(complianceUID, RESOURCE_TYPE_COMPLIANCE, ComplianceSelector, 'compliance');
};

export const useComplianceRuleLoader = (complianceRuleUID) => {
	return useResourceLoader(complianceRuleUID, RESOURCE_TYPE_COMPLIANCE_RULE, ComplianceRuleSelector, 'complianceRule');
};

export const useComplianceHistoryLoader = (complianceHistoryUID) => {
	return useResourceLoader(complianceHistoryUID, RESOURCE_TYPE_COMPLIANCE_HISTORY, ComplianceHistorySelector, 'complianceHistory');
};

export const useEmailTemplateLoader = (templateUID) => {
	return useResourceLoader(templateUID, RESOURCE_TYPE_EMAIL_TEMPLATE, EmailTemplateSelector, 'emailTemplate');
};

export const useEmailVerificationLoader = (verificationUID) => {
	return useResourceLoader(verificationUID, RESOURCE_TYPE_EMAIL_VERIFICATION, EmailVerificationSelector, 'emailVerification');
};

export const useEmailVerificationRecordLoader = (verificationUID) => {
	return useResourceLoader(verificationUID, RESOURCE_TYPE_EMAIL_VERIFICATION_RECORD, EmailVerificationRecordSelector, 'emailVerificationRecord');
};

export const useEmailEventLoader = (eventUID) => {
	return useResourceLoader(eventUID, RESOURCE_TYPE_EMAIL_EVENT, EmailEventSelector, 'emailEvent');
};

export const useSentEmailLoader = (emailUID) => {
	return useResourceLoader(emailUID, RESOURCE_TYPE_SENT_EMAIL, SentEmailSelector, 'sentEmail');
};

export const useMailboxLoader = (mailboxUID) => {
	return useResourceLoader(mailboxUID, RESOURCE_TYPE_MAILBOX, MailboxSelector, 'mailbox');
};

export const useMailboxMetaDataLoader = (metaDataUID) => {
	return useResourceLoader(metaDataUID, RESOURCE_TYPE_MAILBOX_META_DATA, MailboxMetaDataSelector, 'mailboxMetaData');
};

export const useMailboxMessageLoader = (messageUID) => {
	return useResourceLoader(messageUID, RESOURCE_TYPE_MAILBOX_MESSAGE, MailboxMessageSelector, 'mailboxMessage');
};

export const usePermissionEntryLoader = (permissionUID) => {
	return useResourceLoader(permissionUID, RESOURCE_TYPE_PERMISSION_ENTRY, PermissionEntrySelector, 'permissionEntry');
};

export const usePermissionLogEntryLoader = (logEntryUID) => {
	return useResourceLoader(logEntryUID, RESOURCE_TYPE_PERMISSION_LOG_ENTRY, PermissionLogEntrySelector, 'permissionLogEntry');
};

export const usePermissionsOrganizationSettingsLoader = (organizationUID) => {
	return useResourceLoader(organizationUID, RESOURCE_TYPE_PERMISSIONS_ORGANIZATION_SETTINGS, PermissionsOrganizationSettingsSelector, 'permissionsOrganizationSettings');
};

export const useResourcePermissionLoader = (permissionUID) => {
	return useResourceLoader(permissionUID, RESOURCE_TYPE_RESOURCE_PERMISSIONS, ResourcePermissionSelector, 'resourcePermission');
};

export const useOrganizationLoader = (organizationUID) => {
	return useResourceLoader(organizationUID, RESOURCE_TYPE_ORGANIZATION, OrganizationSelector, 'organization');
};

export const useOrganizationResourcePermissionRuleLoader = (ruleUID) => {
	return useResourceLoader(ruleUID, RESOURCE_TYPE_ORGANIZATION_RESOURCE_PERMISSION_RULE, OrganizationResourcePermissionRuleSelector, 'organizationResourcePermissionRule');
};

export const useInvoiceLoader = (invoiceUID) => {
	return useResourceLoader(invoiceUID, RESOURCE_TYPE_INVOICE, InvoiceSelector, 'invoice');
};

export const useInvoiceItemLoader = (invoiceItemUID) => {
	return useResourceLoader(invoiceItemUID, RESOURCE_TYPE_INVOICE_ITEM, InvoiceItemSelector, 'invoiceItem');
};

export const usePaymentRequestLoader = (requestUID) => {
	return useResourceLoader(requestUID, RESOURCE_TYPE_PAYMENT_REQUEST, PaymentRequestSelector, 'paymentRequest');
};

export const useStripePaymentLogLoader = (paymentLogUID) => {
	return useResourceLoader(paymentLogUID, RESOURCE_TYPE_STRIPE_PAYMENT_LOG, StripePaymentLogSelector, 'stripePaymentLog');
};

export const useUserWithdrawLoader = (withdrawUID) => {
	return useResourceLoader(withdrawUID, RESOURCE_TYPE_USER_WITHDRAW, UserWithdrawSelector, 'userWithdraw');
};

export const usePriorityACHPaymentLoader = (paymentUID) => {
	return useResourceLoader(paymentUID, RESOURCE_TYPE_PRIORITY_ACH_PAYMENT, PriorityACHPaymentSelector, 'priorityAchPayment');
};

export const usePriorityACHRecurringPaymentLoader = (recurringPaymentUID) => {
	return useResourceLoader(recurringPaymentUID, RESOURCE_TYPE_PRIORITY_ACH_RECURRING_PAYMENT, PriorityACHRecurringPaymentSelector, 'priorityAchRecurringPayment');
};

export const useLoanApplicationLoader = (applicationUID) => {
	return useResourceLoader(applicationUID, RESOURCE_TYPE_LOAN_APPLICATION, LoanApplicationSelector, 'loanApplication');
};

export const useLoanSystemInfoLoader = (loanInfoUID) => {
	return useResourceLoader(loanInfoUID, RESOURCE_TYPE_LOAN_SYSTEM_INFO, LoanSystemInfoSelector, 'loanSystemInfo');
};

export const useLoanLoader = (loanUID) => {
	return useResourceLoader(loanUID, RESOURCE_TYPE_LOAN, LoanSelector, 'loan');
};

export const useLoanHistoryLoader = (loanUID) => {
	return useResourceLoader(loanUID, RESOURCE_TYPE_LOAN_HISTORY, LoanHistorySelector, 'historyEntry');
};

export const useLoanPaymentLogLoader = (logUID) => {
	return useResourceLoader(logUID, RESOURCE_TYPE_LOAN_PAYMENT_LOG, LoanPaymentLogSelector, 'loanPaymentLog');
};

export const useStripeWebhookLogLoader = (logUID) => {
	return useResourceLoader(logUID, RESOURCE_TYPE_STRIPE_WEBHOOK_LOG, StripeWebhookLogSelector, 'logEntry');
};

export const useUserAccountPaymentProviderInfoLoader = (accountUID) => {
	return useResourceLoader(accountUID, RESOURCE_TYPE_USER_ACCOUNT_PAYMENT_PROVIDER_INFO, UserAccountPaymentProviderInfoSelector, 'info');
};

export const useSezzleOrderLoader = (sezzleOrderUID) => {
	return useResourceLoader(sezzleOrderUID, RESOURCE_TYPE_SEZZLE_ORDER, SezzleOrderSelector, 'sezzleOrder');
};

export const useSezzleWebhookEventLoader = (eventUID) => {
	return useResourceLoader(eventUID, RESOURCE_TYPE_SEZZLE_WEBHOOK_EVENT, SezzleWebhookEventSelector, 'sezzleWebhookEvent');
};

export const useBankAccountLoader = (bankAccountUID) => {
	return useResourceLoader(bankAccountUID, RESOURCE_TYPE_BANK_ACCOUNT, BankAccountSelector, 'bankAccount');
};

export const useBankAccountHistoricalInterestRateLoader = (rateHistoryUID) => {
	return useResourceLoader(rateHistoryUID, RESOURCE_TYPE_BANK_ACCOUNT_HISTORICAL_INTEREST_RATE, BankAccountHistoricalInterestRateSelector, 'bankAccountHistoricalInterestRate');
};

export const useBankAccountInterestLoader = (interestUID) => {
	return useResourceLoader(interestUID, RESOURCE_TYPE_BANK_ACCOUNT_INTEREST, BankAccountInterestSelector, 'bankAccountInterest');
};

export const useBankAccountBalanceRecordLoader = (recordUID) => {
	return useResourceLoader(recordUID, RESOURCE_TYPE_BANK_ACCOUNT_BALANCE_RECORD, BankAccountBalanceRecordSelector, 'bankAccountBalanceRecord');
};

export const useBankTransferLoader = (transferUID) => {
	return useResourceLoader(transferUID, RESOURCE_TYPE_BANK_TRANSFER, BankTransferSelector, 'bankTransfer');
};

export const useBulkFundsTransferLoader = (bulkTransferUID) => {
	return useResourceLoader(bulkTransferUID, RESOURCE_TYPE_BULK_FUNDS_TRANSFER, BulkFundsTransferSelector, 'bulkFundsTransfer');
};

export const useFundsLockLoader = (lockUID) => {
	return useResourceLoader(lockUID, RESOURCE_TYPE_FUNDS_LOCK, FundsLockSelector, 'fundsLock');
};

export const useFundsLockReleaseLogLoader = (releaseLogUID) => {
	return useResourceLoader(releaseLogUID, RESOURCE_TYPE_FUNDS_LOCK_RELEASE_LOG, FundsLockReleaseLogSelector, 'fundsLockReleaseLog');
};

export const useReleasedFundsLockLoader = (lockUID) => {
	return useResourceLoader(lockUID, RESOURCE_TYPE_RELEASED_FUNDS_LOCK, ReleasedFundsLockSelector, 'releasedFundsLock');
};

export const useBalanceSourceTransferLoader = (transferUID) => {
	return useResourceLoader(transferUID, RESOURCE_TYPE_BALANCE_SOURCE_TRANSFER, BalanceSourceTransferSelector, 'balanceSourceTransfer');
};

export const useCreditUserAccountLogLoader = (creditLogUID) => {
	return useResourceLoader(creditLogUID, RESOURCE_TYPE_CREDIT_USER_ACCOUNT_LOG, CreditUserAccountLogSelector, 'creditUserAccountLog');
};

export const useEventLoader = (eventUID) => {
	return useResourceLoader(eventUID, RESOURCE_TYPE_EVENT, EventSelector, 'event');
};

export const useEventHookLoader = (hookUID) => {
	return useResourceLoader(hookUID, RESOURCE_TYPE_EVENT_HOOK, EventHookSelector, 'eventHook');
};

export const useNotificationLoader = (notificationUID) => {
	return useResourceLoader(notificationUID, RESOURCE_TYPE_NOTIFICATION, NotificationSelector, 'notification');
};

export const useActionItemLoader = (itemUID) => {
	return useResourceLoader(itemUID, RESOURCE_TYPE_ACTION_ITEM, ActionItemSelector, 'actionItem');
};

export const useUpdateLogLoader = (entryUID) => {
	return useResourceLoader(entryUID, RESOURCE_TYPE_UPDATE_LOG_ENTRY, UpdateLogSelector, 'updateLog');
};

export const useStorageFileLoader = (fileUID) => {
	return useResourceLoader(fileUID, RESOURCE_TYPE_STORAGE_FILE, StorageFileSelector, 'storageFile');
};

export const useAttachedStorageFilesLoader = (attachedFilesUID) => {
	return useResourceLoader(attachedFilesUID, RESOURCE_TYPE_ATTACHED_STORAGE_FILES, AttachedStorageFilesSelector, 'attachedStorageFiles');
};

export const useSystemHistoryEntryLoader = (entryUID) => {
	return useResourceLoader(entryUID, RESOURCE_TYPE_SYSTEM_HISTORY_ENTRY, SystemHistoryEntrySelector, 'historyEntry');
};

export const useSnapshotLoader = (snapshotUID) => {
	return useResourceLoader(snapshotUID, RESOURCE_TYPE_SNAPSHOT, SnapshotSelector, 'snapshot');
};

export const useIPAddressLoader = (ipUID) => {
	return useResourceLoader(ipUID, RESOURCE_TYPE_IP_ADDRESS, IPAddressSelector, 'ipAddress');
};

export const useKnownIPAddressLoader = (knownIpUID) => {
	return useResourceLoader(knownIpUID, RESOURCE_TYPE_KNOWN_IP_ADDRESS, KnownIPAddressSelector, 'knownIpAddress');
};

export const useUserAgentLoader = (userAgentUID) => {
	return useResourceLoader(userAgentUID, RESOURCE_TYPE_USER_AGENT, UserAgentSelector, 'userAgent');
};

export const useKnownUserAgentLoader = (knownUserAgentUID) => {
	return useResourceLoader(knownUserAgentUID, RESOURCE_TYPE_KNOWN_USER_AGENT, KnownUserAgentSelector, 'knownUserAgent');
};

export const useSystemStatsLoader = (statsUID) => {
	return useResourceLoader(statsUID, RESOURCE_TYPE_SYSTEM_STATS, SystemStatsSelector, 'systemStats');
};

export const useResourceNoteLoader = (notesUID) => {
	return useResourceLoader(notesUID, RESOURCE_TYPE_RESOURCE_NOTE, ResourceNoteSelector, 'resourceNote');
};

export const useDeposifyTagLoader = (tagUID) => {
	return useResourceLoader(tagUID, RESOURCE_TYPE_DEPOSIFY_TAG, DeposifyTagSelector, 'deposifyTag');
};

export const usePermanentLinkLoader = (linkUID) => {
	return useResourceLoader(linkUID, RESOURCE_TYPE_PERMANENT_LINK, PermanentLinkSelector, 'link');
};

export const useOnlineUserLoader = (onlineUserUID) => {
	return useResourceLoader(onlineUserUID, RESOURCE_TYPE_ONLINE_USER, OnlineUserSelector, 'onlineUser');
};

export const useFrontendGeneralSettingsLoader = (settingsUID) => {
	return useResourceLoader(settingsUID, RESOURCE_TYPE_FRONTEND_GENERAL_SETTINGS, FrontendGeneralSettingsSelector, 'frontendGeneralSettings');
};

export const useYardiScreeningWorksProXMLLoader = (xmlUID) => {
	return useResourceLoader(xmlUID, RESOURCE_TYPE_YARDI_SCREENING_WORKS_PRO_XML, YardiScreeningWorksProXMLSelector, 'yardiScreeningWorksProXml');
};

export const useYardiVoyagerXMLLoader = (voyagerXmlUID) => {
	return useResourceLoader(voyagerXmlUID, RESOURCE_TYPE_YARDI_VOYAGER_XML, YardiVoyagerXMLSelector, 'yardiVoyagerXml');
};

export const useYardiVoyagerTransactionLoader = (voyagerTransactionUID) => {
	return useResourceLoader(voyagerTransactionUID, RESOURCE_TYPE_YARDI_VOYAGER_TRANSACTION, YardiVoyagerTransactionSelector, 'yardiVoyagerTransaction');
};

export const useYardiVoyagerResidentLoader = (voyagerResidentUID) => {
	return useResourceLoader(voyagerResidentUID, RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT, YardiVoyagerResidentSelector, 'yardiVoyagerResident');
};

export const useYardiVoyagerResidentCustomColumnLoader = (customColumnUID) => {
	return useResourceLoader(customColumnUID, RESOURCE_TYPE_YARDI_VOYAGER_RESIDENT_CUSTOM_COLUMN, YardiVoyagerResidentCustomColumnSelector, 'yardiVoyagerResidentCustomColumn');
};

export const useYardiVoyagerPropertyUnitLoader = (voyagerPropertyUnitUID) => {
	return useResourceLoader(voyagerPropertyUnitUID, RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY_UNIT, YardiVoyagerPropertyUnitSelector, 'yardiVoyagerPropertyUnit');
};

export const useYardiVoyagerPropertyLoader = (voyagerPropertyUID) => {
	return useResourceLoader(voyagerPropertyUID, RESOURCE_TYPE_YARDI_VOYAGER_PROPERTY, YardiVoyagerPropertySelector, 'yardiVoyagerProperty');
};

export const useYardiVoyagerPMCServiceInterfaceVersionLoader = (serviceInterfaceVersionUID) => {
	return useResourceLoader(serviceInterfaceVersionUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC_SERVICE_INTERFACE_VERSION, YardiVoyagerPMCServiceInterfaceVersionSelector, 'yardiVoyagerPmcServiceInterfaceVersion');
};

export const useYardiVoyagerPMCLoader = (deposifyPmcAccountUID) => {
	return useResourceLoader(deposifyPmcAccountUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC, YardiVoyagerPMCSelector, 'yardiVoyagerPmc');
};

export const useYardiVoyagerPMCCredentialsLoader = (deposifyPmcAccountUID) => {
	return useResourceLoader(deposifyPmcAccountUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC_CREDENTIALS, YardiVoyagerPMCCredentialsSelector, 'yardiVoyagerPmcCredentials');
};

export const useYardiVoyagerPetLoader = (petUID) => {
	return useResourceLoader(petUID, RESOURCE_TYPE_YARDI_VOYAGER_PET, YardiVoyagerPetSelector, 'yardiVoyagerPet');
};

export const useYardiVoyagerILSGuestCardEventLoader = (guestCardEventUID) => {
	return useResourceLoader(guestCardEventUID, RESOURCE_TYPE_YARDI_VOYAGER_ILS_GUEST_CARD_EVENT, YardiVoyagerILSGuestCardEventSelector, 'yardiVoyagerIlsGuestCardEvent');
};

export const useYardiVoyagerChargeLoader = (voyagerChargeUID) => {
	return useResourceLoader(voyagerChargeUID, RESOURCE_TYPE_YARDI_VOYAGER_CHARGE, YardiVoyagerChargeSelector, 'yardiVoyagerCharge');
};

export const useYardiVoyagerChargeCodeLoader = (chargeCodeUID) => {
	return useResourceLoader(chargeCodeUID, RESOURCE_TYPE_YARDI_VOYAGER_CHARGE_CODE, YardiVoyagerChargeCodeSelector, 'yardiVoyagerChargeCode');
};

export const useYardiVoyagerDepositCreateIntentLoader = (createIntentUID) => {
	return useResourceLoader(createIntentUID, RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CREATE_INTENT, YardiVoyagerDepositCreateIntentSelector, 'yardiVoyagerDepositCreateIntent');
};

export const useYardiVoyagerDepositCloseIntentLoader = (closeIntentUID) => {
	return useResourceLoader(closeIntentUID, RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_CLOSE_INTENT, YardiVoyagerDepositCloseIntentSelector, 'yardiVoyagerDepositCloseIntent');
};

export const useYardiVoyagerDepositWithholdIntentLoader = (withholdIntentUID) => {
	return useResourceLoader(withholdIntentUID, RESOURCE_TYPE_YARDI_VOYAGER_DEPOSIT_WITHHOLD_INTENT, YardiVoyagerDepositWithholdIntentSelector, 'yardiVoyagerDepositWithholdIntent');
};

export const useYardiVoyagerEventLoader = (eventUID) => {
	return useResourceLoader(eventUID, RESOURCE_TYPE_YARDI_VOYAGER_EVENT, YardiVoyagerEventSelector, 'yardiVoyagerEvent');
};

export const useYardiVoyagerFlexDepositIntentLoader = (flexIntentUID) => {
	return useResourceLoader(flexIntentUID, RESOURCE_TYPE_YARDI_VOYAGER_FLEX_DEPOSIT_INTENT, YardiVoyagerFlexDepositIntentSelector, 'yardiVoyagerFlexDepositIntent');
};

export const useYardiVoyagerPhoneLoader = (phoneUID) => {
	return useResourceLoader(phoneUID, RESOURCE_TYPE_YARDI_VOYAGER_PHONE, YardiVoyagerPhoneSelector, 'yardiVoyagerPhone');
};

export const useYardiVoyagerOtherOccupantLoader = (otherOccupantUID) => {
	return useResourceLoader(otherOccupantUID, RESOURCE_TYPE_YARDI_VOYAGER_OTHER_OCCUPANT, YardiVoyagerOtherOccupantSelector, 'yardiVoyagerOtherOccupant');
};

export const useYardiVoyagerPMCCustomColumnSettingsLoader = (columnUID) => {
	return useResourceLoader(columnUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC_CUSTOM_COLUMN_SETTINGS, YardiVoyagerPMCCustomColumnSettingsSelector, 'yardiVoyagerPmcCustomColumnSettings');
};

export const useYardiVoyagerPMCStatsLoader = (statsUID) => {
	return useResourceLoader(statsUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS, YardiVoyagerPMCStatsSelector, 'yardiVoyagerPmcStats');
};

export const useYardiVoyagerPMCStatsCollectorLoader = (statsUID) => {
	return useResourceLoader(statsUID, RESOURCE_TYPE_YARDI_VOYAGER_PMC_STATS_COLLECTOR, YardiVoyagerPMCStatsCollectorSelector, 'yardiVoyagerPmcStatsCollector');
};

export const useYardiVoyagerActiveScanLogEntryLoader = (logUID) => {
	return useResourceLoader(logUID, RESOURCE_TYPE_YARDI_VOYAGER_ACTIVE_SCAN_LOG_ENTRY, YardiVoyagerActiveScanLogEntrySelector, 'yardiVoyagerActiveScanLogEntry');
};

export const useYardiVoyagerSystemSettingsLoader = (settingsUID) => {
	return useResourceLoader(settingsUID, RESOURCE_TYPE_YARDI_VOYAGER_SYSTEM_SETTINGS, YardiVoyagerSystemSettingsSelector, 'yardiVoyagerSystemSettings');
};

